export default {
    indexCompanies: { method: 'get',    url: 'companies' },
    createCompany:  { method: 'post',   url: 'companies'},
    updateCompany:  { method: 'put',    url: 'companies/{id}'},
    destroyCompany: { method: 'delete', url: 'companies/{id}'},
}